import { render, staticRenderFns } from "./Slide2.vue?vue&type=template&id=1565c528&scoped=true&"
import script from "./Slide2.vue?vue&type=script&lang=js&"
export * from "./Slide2.vue?vue&type=script&lang=js&"
import style0 from "./Slide2.vue?vue&type=style&index=0&id=1565c528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565c528",
  null
  
)

export default component.exports